import axios from 'axios';
import { utils } from '../../utils/legacy-utils';

export const mapCategoryInfoToCategoryList = async (funnelCategoryAssignedInfoList) => {
    const categories = [];

    Object.keys(funnelCategoryAssignedInfoList).forEach((key) => {
        if (funnelCategoryAssignedInfoList[key].name) {
            categories.push({
                label: funnelCategoryAssignedInfoList[key].name,
                value: Number(utils.removeLongSuffix(funnelCategoryAssignedInfoList[key].id)),
            });
        }
    });

    return categories;
};

export const getAllCategories = async () => {
    const { data } = await axios.get('/app/funnel/categories/getAll');
    const { funnelCategoryAssignedInfoList } = data;

    return mapCategoryInfoToCategoryList(funnelCategoryAssignedInfoList);
};

export const getAllCategoriesAssigned = async (funnelId) => {
    const { data } = await axios.get(`/app/funnel/categories/getAllAssigned?funnelId=${funnelId}`);
    const { longList } = data;

    return longList.map((element) => {
        return Number(utils.removeLongSuffix(element));
    });
};

export const saveCategories = async (funnelId, categoriesSelected, categoryIdsToRemove) => {
    await axios.post(
        `/app/funnel/categories/modify/funnelId=${funnelId}`,
        `categoryIdsToAdd=${categoriesSelected}&categoryIdsToRemove=${categoryIdsToRemove}&categoriesToCreate=`,
    );
};

export const createNewCategories = async (categoriesToCreate) => {
    const { data } = await axios.post(
        '/app/funnel/categories/',
        `categoriesToCreate=${categoriesToCreate}`,
    );

    return data;
};
